import anytimeConsultationApi from "../../api/anytime_consultations";
import { buildAnsweredSearchRequestQuery } from "../../features/anytime-consultation-answered-search";
import * as mutationTypes from "../mutation-types";

const state = {
  anytimeConsultations: [],
  anytimeConsultation: {},
  anytimeConsultationAnswer: {},
  anytimeConsultationKartes: [],
  anytimeConsultationSiblingKartes: [],
  anytimeConsultationReferenceInfo: [],
  anytimeConsultationSearchKeys: null,
  anytimeConsultationFilteredFlag: true,
  elasticsearchErrorDetail: "",
  popupMessage: "",
  totalCount: 0,
  excludedCount: 0,
  hasMore: false,
  offset: 0,
  lastSearchParams: null
};

const getters = {
  anytimeConsultations: state => state.anytimeConsultations,
  anytimeConsultation: state => state.anytimeConsultation,
  anytimeConsultationAnswer: state => state.anytimeConsultationAnswer,
  anytimeConsultationKartes: state => state.anytimeConsultationKartes,
  anytimeConsultationSiblingKartes: state => state.anytimeConsultationSiblingKartes,
  anytimeConsultationReferenceInfo: state => state.anytimeConsultationReferenceInfo,
  anytimeConsultationSearchKeys: state => state.anytimeConsultationSearchKeys,
  anytimeConsultationFilteredFlag: state => state.anytimeConsultationFilteredFlag,
  elasticsearchErrorDetail: state => state.elasticsearchErrorDetail,
  popupMessage: state => state.popupMessage,
  totalCount: state => state.totalCount,
  excludedCount: state => state.excludedCount,
  hasMore: state => state.hasMore,
  offset: state => state.offset,
  lastSearchParams: state => state.lastSearchParams
};

const actions = {
  fetchAnytimeConsultations({ commit }, params) {
    // APIエラーの場合に前の情報が残らないようにする
    let anytimeConsultations = [];
    commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATIONS, { anytimeConsultations });

    return new Promise((resolve) => {
      anytimeConsultationApi.fetchAnytimeConsultations(anytimeConsultations => {
        commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATIONS, { anytimeConsultations });
        resolve();
      }, params);
    });
  },

  fetchAssignedAnytimeConsultations({ commit }, params) {
    // APIエラーの場合に前の情報が残らないようにする
    let anytimeConsultations = [];
    commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATIONS, { anytimeConsultations });

    return new Promise((resolve) => {
      anytimeConsultationApi.fetchAssignedAnytimeConsultations(anytimeConsultations => {
        commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATIONS, { anytimeConsultations });
        resolve();
      }, params);
    });
  },

  fetchCompletedAnytimeConsultations({ commit }, params) {
    // APIエラーの場合に前の情報が残らないようにする
    let anytimeConsultations = [];
    commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATIONS, { anytimeConsultations });

    return new Promise((resolve) => {
      anytimeConsultationApi.fetchCompletedAnytimeConsultations(anytimeConsultations => {
        commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATIONS, { anytimeConsultations });
        resolve();
      }, params);
    });
  },

  answeredSearchAnytimeConsultations({ commit }, params) {
    commit(mutationTypes.ASSIGN_IS_SEARCHING, true);
    // 新規検索時はオフセットを0にして状態をリセット
    commit(mutationTypes.RESET_ANYTIME_CONSULTATIONS);

    const request = {
      query: buildAnsweredSearchRequestQuery(params),
      offset: 0,
    };

    return anytimeConsultationApi.answeredSearchAnytimeConsultations(request)
      .then(response => {
        const anytimeConsultations = response.data || [];
        const totalCount = response.total_count || 0;
        const excludedCount = response.excluded_count || 0;
        const hasMore = response.has_more || false;
        commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATIONS, { anytimeConsultations, totalCount, excludedCount, hasMore });
        // 検索パラメータを保存（追加読み込み時に使用）
        commit(mutationTypes.ASSIGN_SEARCH_PARAMS, { params, offset: anytimeConsultations.length });
      })
      .finally(() => {
        commit(mutationTypes.ASSIGN_IS_SEARCHING, false);
      });
  },

  loadMoreAnytimeConsultations({ commit, state }) {
    commit(mutationTypes.ASSIGN_IS_SEARCHING, true);
    const params = { ...state.lastSearchParams };
    const request = {
      query: buildAnsweredSearchRequestQuery(params),
      offset: state.offset,
    };

    return anytimeConsultationApi.answeredSearchAnytimeConsultations(request)
      .then(response => {
        const anytimeConsultations = response.data || [];
        const hasMore = response.has_more || false;
        const totalCount = response.total_count || 0;
        const excludedCount = response.excluded_count || 0;
        commit(mutationTypes.APPEND_ANYTIME_CONSULTATIONS, { anytimeConsultations, hasMore, totalCount, excludedCount });
        commit(mutationTypes.ASSIGN_SEARCH_PARAMS, { params: state.lastSearchParams, offset: state.offset + anytimeConsultations.length });
      })
      .finally(() => {
        commit(mutationTypes.ASSIGN_IS_SEARCHING, false);
      });
  },

  similarSearchAnytimeConsultations({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit(mutationTypes.ASSIGN_IS_SEARCHING, true);
      anytimeConsultationApi.similarSearchAnytimeConsultations(params,
        (anytimeConsultations) => {
          commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATIONS, { anytimeConsultations });
          commit(mutationTypes.ASSIGN_IS_SEARCHING, false);
          const elasticsearchErrorDetail = "";
          commit(mutationTypes.ASSIGN_ELASTICSEARCH_ERROR_DETAIL, { elasticsearchErrorDetail });
          resolve();
        },
        (error) => {
          commit(mutationTypes.ASSIGN_IS_SEARCHING, false);
          const elasticsearchErrorDetail = error.response.data["message"];
          commit(mutationTypes.ASSIGN_ELASTICSEARCH_ERROR_DETAIL, { elasticsearchErrorDetail });
          reject();
        }
      );
    });
  },

  bulkExcludeAnytimeConsultations(_ctx, params) {
    return anytimeConsultationApi.bulkExcludeAnytimeConsultations(params);
  },

  bulkUnexcludeAnytimeConsultations(_ctx, params) {
    return anytimeConsultationApi.bulkUnexcludeAnytimeConsultations(params);
  },

  findAnytimeConsultation({ commit }, params) {
    return new Promise((resolve) => {
      anytimeConsultationApi.findAnytimeConsultation(anytimeConsultation => {
        commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION, { anytimeConsultation });
        resolve();
      }, params);
    });
  },

  findAnytimeConsultationAnswer({ commit }, params) {
    return new Promise((resolve) => {
      anytimeConsultationApi.findAnytimeConsultationAnswer(anytimeConsultationAnswer => {
        commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER, { anytimeConsultationAnswer });
        resolve();
      }, params);
    });
  },

  saveAnytimeConsultationAnswerDraft({ commit }, params) {
    return new Promise((resolve, reject) => {
      anytimeConsultationApi.saveAnytimeConsultationAnswerDraft(params,
        // success
        anytimeConsultationAnswer => {
          commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER, { anytimeConsultationAnswer });
          resolve();
        },
        error => {
          const popupMessage = error.response.data["message"];
          if (popupMessage) {
            commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER_POPUP_MESSAGE, { popupMessage });
          } else {
            console.error(error);
          }
          reject();
        }
      );
    });
  },

  completeAnytimeConsultationAnswer({ commit }, params) {
    return new Promise((resolve, reject) => {
      anytimeConsultationApi.completeAnytimeConsultationAnswer(params,
        anytimeConsultationAnswer => {
          commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER, { anytimeConsultationAnswer });
          resolve();
        },
        error => {
          const popupMessage = error.response.data["message"];
          if (popupMessage) {
            commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER_POPUP_MESSAGE, { popupMessage });
          } else {
            console.error(error);
          }
          reject();
        }
      );
    });
  },

  cancelAnytimeConsultationAnswer({ commit }, params) {
    return new Promise((resolve, reject) => {
      anytimeConsultationApi.cancelAnytimeConsultationAnswer(
        params,
        anytimeConsultationAnswer => {
          commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER, { anytimeConsultationAnswer });
          resolve();
        },
        error => {
          const popupMessage = error.response.data["message"];
          if (popupMessage) {
            commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER_POPUP_MESSAGE, { popupMessage });
          } else {
            console.error(error);
          }
          reject();
        });
    });
  },

  fetchAnytimeConsultationKartes({ commit }, params) {
    return new Promise((resolve) => {
      anytimeConsultationApi.fetchAnytimeConsultationKartes(anytimeConsultationKartes => {
        commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_KARTES, { anytimeConsultationKartes });
        resolve();
      }, params);
    });
  },

  fetchAnytimeConsultationSiblingKartes({ commit }, params) {
    return new Promise((resolve) => {
      anytimeConsultationApi.fetchAnytimeConsultationSiblingKartes(anytimeConsultationSiblingKartes => {
        commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_SIBLING_KARTES, { anytimeConsultationSiblingKartes });
        resolve();
      }, params);
    });
  },

  findAnytimeConsultationReferenceInfo({ commit }, params) {
    return new Promise((resolve) => {
      anytimeConsultationApi.findAnytimeConsultationReferenceInfo(anytimeConsultationReferenceInfo => {
        commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_REFERENCE_INFO, { anytimeConsultationReferenceInfo });
        resolve();
      }, params);
    });
  },

  assignAnytimeConsultationSearchKeys({ commit }, searchKeys) {
    commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_SEARCH_KEYS, { searchKeys });
  },

  assignFilteredFlag({ commit }, filtered) {
    commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_FILTERED_FLAG, { filtered });
  },

  clearAnytimeConsultationObjects({ commit }) {
    let anytimeConsultation = {};
    commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION, { anytimeConsultation });
    let anytimeConsultationAnswer = {};
    commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER, { anytimeConsultationAnswer });
    let anytimeConsultationReferenceInfo = [];
    commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_REFERENCE_INFO, { anytimeConsultationReferenceInfo });
  },

  clearAnytimeConsultationSearchTabObjects({ commit }) {
    let anytimeConsultations = [];
    commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATIONS, { anytimeConsultations });
    let elasticsearchErrorDetail = "";
    commit(mutationTypes.ASSIGN_ELASTICSEARCH_ERROR_DETAIL, { elasticsearchErrorDetail });
  },

  clearAnytimeConsultationKartes({ commit }) {
    let anytimeConsultationKartes = [];
    commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_KARTES, { anytimeConsultationKartes });
  },

  clearAnytimeConsultationSiblingKartes({ commit }) {
    let anytimeConsultationSiblingKartes = [];
    commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_SIBLING_KARTES, { anytimeConsultationSiblingKartes });
  },

  deleteAnytimeConsultationAnswer({ commit }, params) {
    return new Promise((resolve, reject) => {
      anytimeConsultationApi.deleteAnytimeConsultationAnswer(
        params,
        anytimeConsultationAnswer => {
          commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER, { anytimeConsultationAnswer });
          resolve();
        },
        error => {
          const popupMessage = error.response.data["message"];
          if (popupMessage) {
            commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER_POPUP_MESSAGE, { popupMessage });
          } else {
            console.error(error);
          }
          // ステータスが変更されている場合があるのでデータを再読込する
          anytimeConsultationApi.findAnytimeConsultationAnswer(anytimeConsultationAnswer => {
            commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER, { anytimeConsultationAnswer });
          }, params);
          reject();
        });
    });
  },
};


const mutations = {
  [mutationTypes.ASSIGN_ANYTIME_CONSULTATIONS](state, { anytimeConsultations, totalCount, excludedCount, hasMore }) {
    state.anytimeConsultations = anytimeConsultations;
    if (totalCount !== undefined) state.totalCount = totalCount;
    if (excludedCount !== undefined) state.excludedCount = excludedCount;
    if (hasMore !== undefined) state.hasMore = hasMore;
  },

  [mutationTypes.APPEND_ANYTIME_CONSULTATIONS](state, { anytimeConsultations, hasMore, totalCount, excludedCount }) {
    state.anytimeConsultations = [...state.anytimeConsultations, ...anytimeConsultations];
    if (hasMore !== undefined) state.hasMore = hasMore;
    if (totalCount !== undefined) state.totalCount = totalCount;
    if (excludedCount !== undefined) state.excludedCount = excludedCount;
  },

  [mutationTypes.RESET_ANYTIME_CONSULTATIONS](state) {
    state.anytimeConsultations = [];
    state.totalCount = 0;
    state.excludedCount = 0;
    state.hasMore = false;
    state.offset = 0;
  },

  [mutationTypes.ASSIGN_ANYTIME_CONSULTATION](state, { anytimeConsultation }) {
    state.anytimeConsultation = anytimeConsultation;
  },

  [mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER](state, { anytimeConsultationAnswer }) {
    state.anytimeConsultationAnswer = anytimeConsultationAnswer;
  },

  [mutationTypes.SET_ANYTIME_CONSULTATION_ANSWER_CONTENT](state, { content }) {
    state.anytimeConsultationAnswer = {
      ...state.anytimeConsultationAnswer,
      content,
    };
  },

  [mutationTypes.ASSIGN_ANYTIME_CONSULTATION_KARTES](state, { anytimeConsultationKartes }) {
    state.anytimeConsultationKartes = anytimeConsultationKartes;
  },

  [mutationTypes.ASSIGN_ANYTIME_CONSULTATION_SIBLING_KARTES](state, { anytimeConsultationSiblingKartes }) {
    state.anytimeConsultationSiblingKartes = anytimeConsultationSiblingKartes;
  },

  [mutationTypes.ASSIGN_ANYTIME_CONSULTATION_REFERENCE_INFO](state, { anytimeConsultationReferenceInfo }) {
    state.anytimeConsultationReferenceInfo = anytimeConsultationReferenceInfo;
  },

  [mutationTypes.ASSIGN_ANYTIME_CONSULTATION_SEARCH_KEYS](state, { searchKeys }) {
    state.anytimeConsultationSearchKeys = searchKeys;
  },

  [mutationTypes.ASSIGN_ANYTIME_CONSULTATION_FILTERED_FLAG](state, { filtered }) {
    state.anytimeConsultationFilteredFlag = filtered;
  },

  [mutationTypes.ASSIGN_ELASTICSEARCH_ERROR_DETAIL](state, { elasticsearchErrorDetail }) {
    state.elasticsearchErrorDetail = elasticsearchErrorDetail;
  },

  [mutationTypes.ASSIGN_ANYTIME_CONSULTATION_ANSWER_POPUP_MESSAGE](state, { popupMessage }) {
    state.popupMessage = popupMessage;
  },

  [mutationTypes.ASSIGN_SEARCH_PARAMS](state, { params, offset }) {
    state.lastSearchParams = params;
    state.offset = offset;
  }
};


export default {
  state,
  getters,
  actions,
  mutations
};
